import React, { useEffect, useState } from "react";

import { Loading } from "components/common";
import _ from "lodash";
import MetricContainer from "./containers/singleMetric/Metric.container";
import MapTemperatureContainer from "./maps/MapTemperature.container";
import MapCo2Container from "./maps/MapCo2.container";
import MapLuxContainer from "./maps/MapLux.container";
import MapUmidityContainer from "./maps/MapUmidity.container";
import MapBarPressContainer from "./maps/MapBarPress.container";
import MapPCountContainer from "./maps/MapPCount.container";
import TwoMetricContainer from "./containers/twoMetrics/TwoMetric.container";
import MapRainContainer from "./maps/MapRain.container";
import MapPMContainer from "./maps/MapPM.container";
import WindMetriContainer from "./containers/windMetric/WindMetric.container";
import MapWindSpeed from "./maps/MapWindSpeed.container";
import {
  propsBarPressCard,
  propsCo2Card,
  propsLuxCard,
  propsPCountCard,
  propsPMCard,
  propsRainGenericCard,
  propsTempertureCard,
  propsUmidityCard,
} from "constants/metrics";
import { useTranslation } from "react-i18next";

const MetricRenderContainer = ({
  metric,
  viewHorChart,
  data,
  dataDouble,
  dataStations,
  viewBarChart }) => {
  const [loading, setLoading] = useState(true);
  const [propsMetric, setPropsMetric] = useState(null);
  const { t } = useTranslation();
  const [dataMetric1, setDataMetric1] = useState(null)
  const [dataMetric2, setDataMetric2] = useState(null)

  useEffect(() => {
    if (dataStations?.stations && data?.by_station) {
      let union = [];

      data?.by_station?.map((station) => {
        const obj = _.find(
          dataStations?.stations,
          (item) => item?.stationId === station?.station
        );
        union.push({
          ...obj,
          ...station,
        });

        return obj;
      });

      setDataMetric1(union)
    }


  }, [data, dataStations])

  useEffect(() => {
    if (dataStations?.stations && dataDouble?.by_station) {
      let union = [];

      dataDouble?.by_station?.map((station) => {
        const obj = _.find(
          dataStations?.stations,
          (item) => item?.stationId === station?.station
        );
        union.push({
          ...obj,
          ...station,
        });

        return obj;
      });

      setDataMetric2(union)
    }


  }, [dataDouble, dataStations])

  useEffect(() => {
    if (dataMetric1 && metric) {
      setPropsMetric({
        air_temp: {
          map: <MapTemperatureContainer data={dataMetric1} />,
          ...propsTempertureCard,
        },
        air_hum: {
          map: <MapUmidityContainer data={dataMetric1} />,
          ...propsUmidityCard,
        },
        CO2: {
          map: <MapCo2Container data={dataMetric1} />,
          ...propsCo2Card,
          shapes: [
            {
              type: "line",
              xref: "paper",
              x0: 0,
              y0: 700,
              x1: 1,
              y1: 700,
              text: "test",
              line: {
                color: "red",
                width: 2,
              },
            },
          ],
        },
        lux: {
          map: <MapLuxContainer data={dataMetric1} />,
          ...propsLuxCard,
        },
        bar_press: {
          map: <MapBarPressContainer data={dataMetric1} />,
          ...propsBarPressCard,
        },
        pcount: {
          map: <MapPCountContainer data={dataMetric1} />,
          ...propsPCountCard,
        },
        "pm10,pm2_5": {
          xRange: dataMetric1?.time
            ? [dataMetric1?.time[0], dataMetric1?.time[dataMetric1?.time.lenght - 1]]
            : [],

          map: <MapPMContainer data={dataMetric1} dataDouble={dataMetric2} />,
          ...propsPMCard,
        },
        "rain_intensity,rain_intensity_peak": {
          xRange: dataMetric1?.time
            ? [dataMetric1?.time[0], dataMetric1?.time[dataMetric1?.time.lenght - 1]]
            : [],
          map: <MapRainContainer data={dataMetric1} />,
          ...propsRainGenericCard,
        },
      });
      setLoading(false);
    }
  }, [metric, dataMetric1, t, dataMetric2]);

  return loading ? (
    <Loading />
  ) : metric?.value === "rain_intensity,rain_intensity_peak" ||
    metric?.value === "pm10,pm2_5" ? (
    <TwoMetricContainer
      data={data}
      dataDouble={dataDouble}
      viewHorChart={viewHorChart}
      viewBarChart={viewBarChart}
      metric={metric}
      {...propsMetric[metric?.value]}
    >
      {data?.by_station !== null &&
        !_.isEmpty(data?.by_station) &&
        !_.isEmpty(data?.by_station?.filter((item) => item.data !== null)) &&
        propsMetric[metric?.value].map}
    </TwoMetricContainer>
  ) : metric?.value === "wind_speed,wind_dir_idx" ? (
    <WindMetriContainer
      data={data}
      dataDouble={dataDouble}
      viewHorChart={viewHorChart}
      viewBarChart={viewBarChart}
      xRange={
        data?.time ? [data?.time[0], data?.time[data?.time.lenght - 1]] : []
      }
    >
      {data?.by_station !== null &&
        !_.isEmpty(data?.by_station) &&
        !_.isEmpty(data?.by_station?.filter((item) => item.data !== null)) && (
          <MapWindSpeed data={dataMetric1} />
        )}
    </WindMetriContainer>
  ) : (
    <MetricContainer
      metric={metric}
      data={data}
      viewHorChart={viewHorChart}
      viewBarChart={viewBarChart}
      {...propsMetric[metric?.value]}
    >
      {data?.by_station !== null &&
        !_.isEmpty(data?.by_station) &&
        !_.isEmpty(data?.by_station.filter((item) => item?.data !== null)) &&
        propsMetric[metric?.value].map}
    </MetricContainer>
  );
};

export default MetricRenderContainer;
